<template>
  <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <TreeModel type="device" @on-select-change="onSelectChange" />
      </div>
      <div slot="right" class="demo-split-pane">
        <div id="container" style="width:100%; height:100%"></div>
      </div>
    </Split>

  </div>
</template>

<script>
import api from "../../../../api/request.js";
import Cookies from "js-cookie";
import TreeModel from "../area/mods/tree.vue";

const URL = {
    GetUserDevicesPageV2: 'api/CommElecDevice/GetUserDevicesPageV2'
};

export default {
  components: {
    TreeModel
  },
  data() {
    return {
      height: window.innerHeight - 270,
      split1: 0.2,
      parameter: '', // 参数
      map: null, // 地图
      dataList: [], // 设备数据
      point: null, // 位置信息
      cityName: Cookies.get('cityName') || '浙江省-杭州市',
    };
  },
  computed: {

  },
  mounted() {
    window.addEventListener("resize", this.getWindowInfo);
    this.getUserDevicesPageV2();
    this.initMap();
  },
  methods: {
    onSelectChange(item) {
      this.parameter = "";
      switch (item.grade) {
        case 1:
          this.parameter = `&Ccode=${item.Ccode}`;
          break;
        case 2:
          this.parameter = `&Vcode=${item.Vcode}`;
          break;
        case 3:
          this.parameter = `&Scode=${item.Scode}`;
          break;
        case 4:
          this.parameter = `&Zcode=${item.Zcode}`;
          break;
        case 5:
          this.parameter = `&RoomCode=${item.RoomCode}`;
          break;
        default:
          break;
      }
      if (item.Jd && item.Wd) {
        this.point = new BMap.Point(item.Jd, item.Wd)
      } else {
        this.point = null
      }
      this.initMap();
      this.getUserDevicesPageV2();
    },
    getWindowInfo() {
      this.height = window.innerHeight - 270;
    },
    getUserDevicesPageV2() {
        const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
            Cookies.get("AdminData")
        );
        api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetUserDevicesPageV2}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&pageIndex=1&pageSize=100${this.parameter}&deviceType=qg&isAdmin=${IsAdmin}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      )
        .then((res) => {
          if (res.Success) {
            this.dataList = res.Data;
            this.mapAddMarker();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 加载地图数据
    initMap() {
      this.map = new BMap.Map("container");
      this.map.centerAndZoom(new BMap.Point(120.58,28.08), 12);
      this.map.enableScrollWheelZoom(true);
    },

    // 地图添加Marker
    mapAddMarker() {
      let _this = this;
      if (_this.map) {
        _this.map.clearOverlays();
        _this.dataList.forEach(item => {
          // 创建图标
          let myIcon = new BMap.Icon(
            item.IsOnline ? require("../../../../assets/electricity/greenmaker1.png") : require("../../../../assets/electricity/greenmaker1.png"),
            new BMap.Size(100, 100)
          );
          var markers = new BMap.Marker(
            new BMap.Point(item.Longitude, item.Latitude), {
              icon: myIcon
            }
          )
          var label = new BMap.Label(item.UserDeviceName, {
						offset: new BMap.Size(25, 5)
					});

					label.setStyle({
						color: "#ffffff",
						fontSize: "0.6vw",
						height: "1.5vw",
						padding: "0 0.5vw",
						marginTop: "-0.5vw",
						borderRadius: "0.25vw",
						border: "0.05vw solid rgba(15,72,151,0.7)",
						backgroundColor: "rgba(15,72,151,0.7)",
						marginLeft: "0.5vw",
						lineHeight: "1.35vw",
						fontFamily: "微软雅黑"
					});
          // 在地图上添加点标记
          _this.map.addOverlay(markers);
          markers.setLabel(label);

        })

      }
    },

  }
};
</script>

<style scoped>
.demo-split {
  height: 100%;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  height: 100%;
  padding: 10px 20px;
  overflow-y: auto;
}
.btn-view {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
}
.from-view {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.from-label {
  width: 100px;
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
.head-view {
  height: 40px;
  width: 100%;
  background-color: rgb(243, 245, 249);
  padding-left: 10px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/map_home/index.vue